<template>
  <div class="theoryexam">
    <div class="exampaper">
      <div class="paper" ref="paper">
        <div class="content">
          <div class="header">
            <div class="score" v-if="isChecked">{{ scoreData }}</div>
            <h2>{{ testlist && testlist.taskTitle }}</h2>
            <button class="back" @click="tocourse">返回课程</button>
            <div class="paperTotal">
              <b
                >◇ 本试卷共为{{
                  testlist &&
                  testlist.judgeNum + testlist.multiNum + testlist.singleNum
                }}道题目，作答时间为{{
                  testlist && testlist.examTime
                }}分钟，总分{{ testlist && testlist.totalScore }}分,{{
                  testlist && testlist.passScore
                }}分及格。</b
              >
            </div>
          </div>
          <div :class="isChecked ? 'body is_checked' : 'body'">
            <div class="left">
              <div class="single" v-if="single.length !== 0">
                <div class="title">
                  一、单项选择题（本类题共{{ single.length }}题，共{{
                    testlist.singleNum * testlist.perSingle
                  }}分。每题只有一个正确答案，请从备选答案中选出一个你认为正确的答案。）
                </div>
                <a
                  :name="'single' + index"
                  :id="'single' + index"
                  class="item"
                  v-for="(item, index) in single"
                  :key="index"
                >
                  <img
                    v-if="isChecked"
                    :src="item.answer === item.isAnswer ? rightUrl : wrongUrl"
                    alt=""
                  />
                  <div class="stem">
                    {{ index + 1 }}. {{ item.title }} （本题{{
                      testlist.perSingle
                    }}分）
                  </div>
                  <div class="answer">
                    <a-radio-group
                      @change="(e) => singleChange(e, item)"
                      v-model="item.isAnswer"
                      :disabled="true"
                      v-if="isChecked"
                    >
                      <a-radio
                        :style="radioStyle"
                        :value="options[index]"
                        v-for="(value, index) in item.option.split('&&')"
                        :key="index"
                      >
                        {{ options[index] }}、{{ value }}
                      </a-radio>
                    </a-radio-group>
                    <a-radio-group
                      @change="(e) => singleChange(e, item)"
                      v-else
                      v-model="item.isAnswer"
                    >
                      <a-radio
                        :style="radioStyle"
                        :value="options[index]"
                        v-for="(value, index) in item.option.split('&&')"
                        :key="index"
                      >
                        {{ options[index] }}、{{ value }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                  <div v-if="isChecked" class="question_analysis">
                    <p>
                      正确答案：<span class="right_answer">{{
                        item.answer
                      }}</span>
                      <i></i> 您的答案：<span
                        :class="
                          item.answer === item.isAnswer
                            ? 'right_answer'
                            : 'my_answer'
                        "
                        >{{ item.isAnswer || "未作答" }}</span
                      >
                    </p>
                    <p>解析：{{ item.analyse || "无" }}</p>
                  </div>
                </a>
              </div>
              <div class="checked" v-if="checked.length !== 0">
                <div class="title">
                  {{
                    testlist.singleNum === 0 ? "一" : "二"
                  }}、多项选择题（本类题共{{ testlist.multiNum }}题，共{{
                    testlist.multiNum * testlist.perMulti
                  }}分。每题备选答案中，有多个符合题意的正确答案。）
                </div>
                <a
                  class="item"
                  :name="'checked' + index"
                  :id="'checked' + index"
                  v-for="(item, index) in checked"
                  :key="index"
                >
                  <img
                    v-if="isChecked"
                    :src="item.answer === item.isAnswer ? rightUrl : wrongUrl"
                    alt=""
                  />
                  <div class="stem">
                    {{ single.length + index + 1 }}. {{ item.title }} （本题{{
                      testlist.perMulti
                    }}分）
                  </div>
                  <div class="answer">
                    <a-checkbox-group
                      @change="(e) => checkChange(e, item)"
                      v-if="isChecked"
                      :disabled="true"
                      :value="item.isAnswer && item.isAnswer.split('')"
                    >
                      <a-row>
                        <a-col
                          :span="24"
                          :value="index"
                          v-for="(value, index) in item.option.split('&&')"
                          :key="index"
                        >
                          <a-checkbox :value="options[index]">
                            {{ options[index] }}、{{ value }}</a-checkbox
                          >
                        </a-col>
                      </a-row>
                    </a-checkbox-group>
                    <a-checkbox-group
                      @change="(e) => checkChange(e, item)"
                      v-else
                      :value="item.isAnswer && item.isAnswer.split('')"
                    >
                      <a-row>
                        <a-col
                          :span="24"
                          :value="index"
                          v-for="(value, index) in item.option.split('&&')"
                          :key="index"
                        >
                          <a-checkbox :value="options[index]">
                            {{ options[index] }}、{{ value }}</a-checkbox
                          >
                        </a-col>
                      </a-row>
                    </a-checkbox-group>
                  </div>
                  <div v-if="isChecked" class="question_analysis">
                    <p>
                      正确答案：<span class="right_answer">{{
                        item.answer
                      }}</span>
                      <i></i> 您的答案：<span
                        :class="
                          item.answer === item.isAnswer
                            ? 'right_answer'
                            : 'my_answer'
                        "
                        >{{ item.isAnswer || "未作答" }}</span
                      >
                    </p>
                    <p>解析：{{ item.analyse || "无" }}</p>
                  </div>
                </a>
              </div>
              <div class="judge" v-if="judge.length !== 0">
                <div class="title">
                  {{ judgeIndex }}、判断题（本类题共{{ judge.length }}题，共{{
                    testlist.judgeNum * testlist.perJudge
                  }}分。请判断每题的表述是否正确。）。
                </div>
                <a
                  class="item"
                  :name="'judge' + index"
                  :id="'judge' + index"
                  v-for="(item, index) in judge"
                  :key="index"
                >
                  <img
                    v-if="isChecked"
                    :src="item.answer === item.isAnswer ? rightUrl : wrongUrl"
                    alt=""
                  />
                  <div class="stem">
                    {{ single.length + checked.length + index + 1 }}.
                    {{ item.title }} （本题{{ testlist.perJudge }}分）
                  </div>
                  <div class="answer">
                    <a-radio-group
                      @change="(e) => judgeChange(e, item)"
                      v-if="isChecked"
                      :disabled="true"
                      v-model="item.isAnswer"
                    >
                      <a-radio :style="radioStyle" value="正确">正确</a-radio>
                      <a-radio :style="radioStyle" value="错误">错误</a-radio>
                    </a-radio-group>
                    <a-radio-group
                      @change="(e) => judgeChange(e, item)"
                      v-else
                      v-model="item.isAnswer"
                    >
                      <a-radio :style="radioStyle" value="正确">正确</a-radio>
                      <a-radio :style="radioStyle" value="错误">错误</a-radio>
                    </a-radio-group>
                  </div>
                  <div v-if="isChecked" class="question_analysis">
                    <p>
                      正确答案：<span class="right_answer">{{
                        item.answer
                      }}</span>
                      <i></i> 您的答案：<span
                        :class="
                          item.answer === item.isAnswer
                            ? 'right_answer'
                            : 'my_answer'
                        "
                        >{{ item.isAnswer || "未作答" }}</span
                      >
                    </p>
                    <p>解析：{{ item.analyse || "无" }}</p>
                  </div>
                </a>
              </div>
            </div>
            <div :class="fixed ? 'right fixed' : 'right'" ref="rightBox">
              <div class="header">
                <a-icon type="clock-circle" /><span>剩余时间</span>{{ endTime }}
              </div>
              <div class="right_content">
                <div>
                  <a-collapse
                    defaultActiveKey="1"
                    :activeKey="defaultActiveKey"
                  >
                    <a-collapse-panel
                      v-if="single.length !== 0"
                      :header="'一、单选题'"
                      key="1"
                    >
                      <p v-if="isChecked">
                        <a
                          class="index"
                          @click="goAnchor('#single' + index)"
                          v-for="(value, index) in single"
                          :class="
                            value.isAnswer === value.answer
                              ? 'right_item index'
                              : 'wrong_item index'
                          "
                          :key="index"
                        >
                          {{ index + 1 }}
                        </a>
                      </p>
                      <p v-else>
                        <a
                          class="index"
                          @click="goAnchor('#single' + index)"
                          v-for="(value, index) in single"
                          :class="value.isAnswer ? 'isAnswer index' : 'index'"
                          :key="index"
                        >
                          {{ index + 1 }}
                        </a>
                      </p>
                    </a-collapse-panel>
                    <a-collapse-panel
                      v-if="checked.length !== 0"
                      :header="
                        single.length === 0
                          ? '一' + '、多选题'
                          : '二' + '、多选题'
                      "
                      key="2"
                    >
                      <p v-if="isChecked">
                        <a
                          class="index"
                          v-for="(value, index) in checked"
                          :key="index"
                          @click="goAnchor('#checked' + index)"
                          :class="
                            value.isAnswer === value.answer
                              ? 'right_item index'
                              : 'wrong_item index'
                          "
                        >
                          {{ single.length + index + 1 }}
                        </a>
                      </p>
                      <p v-else>
                        <a
                          class="index"
                          v-for="(value, index) in checked"
                          :key="index"
                          @click="goAnchor('#checked' + index)"
                          :class="value.isAnswer ? 'isAnswer index' : 'index'"
                        >
                          {{ single.length + index + 1 }}
                        </a>
                      </p>
                    </a-collapse-panel>
                    <a-collapse-panel
                      v-if="judge.length !== 0"
                      :header="judgeIndex + '、判断题'"
                      key="3"
                    >
                      <p v-if="isChecked">
                        <a
                          class="index"
                          v-for="(value, index) in judge"
                          @click="goAnchor('#judge' + index)"
                          :key="index"
                          :class="
                            value.isAnswer === value.answer
                              ? 'right_item index'
                              : 'wrong_item index'
                          "
                        >
                          {{ single.length + checked.length + index + 1 }}
                        </a>
                      </p>
                      <p v-else>
                        <a
                          class="index"
                          v-for="(value, index) in judge"
                          @click="goAnchor('#judge' + index)"
                          :key="index"
                          :class="value.isAnswer ? 'isAnswer index' : 'index'"
                        >
                          {{ single.length + checked.length + index + 1 }}
                        </a>
                      </p>
                    </a-collapse-panel>
                  </a-collapse>
                </div>
              </div>
              <div class="footer">
                <div v-if="isChecked">
                  正确<cite class="right_target"></cite> 错误<cite
                    class="wrong_target"
                  ></cite>
                </div>
                <div v-else>
                  已答<cite class="had"></cite> 未答<cite
                    class="not_had"
                  ></cite>
                </div>
                <button v-if="!isChecked" @click="submitPaper()">交卷</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a-back-top />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let min = 0;
let sec = 0;
import entry from "../units/entryDetry.js";
import { formatDate } from "@/units/format.js";
import decrypt from "../units/decrypt.js";
import {
  getcourseDetailApi,
  getcatalogApi,
  getcatDetail,
  getcommitPaperApi,
  getupdateStatusApi,
  getscheduledAnswerApi,
} from "@/request/api";
export default {
  name: "theoryexam",
   sockets:{
    studyStart(){
      console.log("进入任务")
    },
    studyEnd(){
      console.log("离开任务")
    }
     // studyStart 进入任务后发送 courseId taskId
      // studyEnd 离开任务后发送 couseId taskId
  },
  data() {
    return {
      testId: null,
      list: [],
      munelist: [],
      currentId: null,
      paperId: null,
      menuId: null,
      testlist: null,
      key: null,
      iv: null,
      type: null,
      userAnswer: null,
      timer: null,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
        fontSize: "16px",
      },
      examId: null,
      single: [],
      checked: [],
      judge: [],
      fixed: false,
      options: ["A", "B", "C", "D", "E", "F"],
      isChecked: false,
      wrongUrl: require("../assets/course/wrong.png"),
      rightUrl: require("../assets/course/right.png"),
      time: "",
      examinee_answer: [],
      defaultActiveKey: "1",
      during_time: 0,
      subinfo: {
        userAnswer: "",
        courseId: "",
        taskId: "",
        timeUse: "",
        paperId: "",
        type: "",
        startTime: "",
      },
      isFinished: false,
      chapterId: "",
    };
  },
  watch: {
    testlist: function () {
      this.single = this.testlist.paperInfo
        .filter((item) => item.type == 0)
        .map((item) => ({ ...item, score: this.testlist.perSingle }));
      this.checked = this.testlist.paperInfo
        .filter((item) => item.type == 1)
        .map((item) => ({ ...item, score: this.testlist.perMulti }));
      this.judge = this.testlist.paperInfo
        .filter((item) => item.type == 2)
        .map((item) => ({ ...item, score: this.testlist.perJudge }));
      // this.time=this.testlist.examTime*60*1000
    },
    userAnswer: function () {
      this.checkInit();
    },
  },
  mounted() {
    document.addEventListener("scroll", this.Scroll);
    
    window.onbeforeunload = function (e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "关闭提示";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    };
    document.oncontextmenu = function () {
      event.returnValue = false;
    };
  },
  created() {
    if (this.$route.query.paperId) {
      this.paperId = JSON.parse(this.$Base64.decode(this.$route.query.paperId));
    }
    this.subinfo.courseId = JSON.parse(
      this.$Base64.decode(this.$route.query.id)
    );
    this.testId = JSON.parse(this.$Base64.decode(this.$route.query.id));
    this.subinfo.taskId = JSON.parse(
      this.$Base64.decode(this.$route.query.menuId)
    );
    this.menuId = JSON.parse(this.$Base64.decode(this.$route.query.menuId));
    this.isFinished = JSON.parse(
      this.$Base64.decode(this.$route.query.isFinished)
    );
    if (this.$route.query.chapterId) {
      this.chapterId = JSON.parse(
        this.$Base64.decode(this.$route.query.chapterId)
      );
    }
    // this.paperId = decrypt.GetQueryParamOfObjEntry("paperId");
    // this.subinfo.courseId = decrypt.GetQueryParamOfObjEntry("id");
    // this.testId =  decrypt.GetQueryParamOfObjEntry("id");
    // this.subinfo.taskId =  decrypt.GetQueryParamOfObjEntry("menuId");
    // this.menuId =  decrypt.GetQueryParamOfObjEntry("menuId");
    // this.isFinished =  decrypt.GetQueryParamOfObjEntry("isFinished");
    // this.chapterId =  decrypt.GetQueryParamOfObjEntry("chapterId");

    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$socket.emit("studyEnd",{courseId: this.testId, taskId: this.menuId})
    if (localStorage.getItem("clear") || this.isChecked) {
      next();
    } else {
      this.$confirm({
        title: "答题未完成，离开后将自动交卷，确定继续？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          let single = this.single.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          let checked = this.checked.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          let judge = this.judge.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          //加密Encrypt(JSON.stringify ...)
          this.subinfo.userAnswer = entry.Encrypt(
            JSON.stringify([...single, ...checked, ...judge]),
            "w2SIy2Hx%2i!tTCd-ikwHEv_kQmB58xI",
            "R7#54X&gLB!6Q&s="
          );
          this.subinfo.timeUse =
            (this.testlist.examTime * 60 * 1000 - this.time) / 1000 / 60;
          this.subinfo.paperId = this.paperId;
          this.subinfo.type = this.type;
          this.getToken(
            getcommitPaperApi,
            {
              ...this.subinfo,
              startTime: formatDate("yyyy-MM-dd hh:mm:ss", new Date()),
            },
            () => {
              this.getToken(
                getupdateStatusApi,
                {
                  taskId: this.subinfo.taskId,
                  courseId: this.subinfo.courseId,
                  status: 1,
                },
                () => {
                  this.$store.commit("getIds", {
                    chapterId: this.chapterId,
                    taskId: this.subinfo.taskId,
                  });
                }
              );
            }
          );
          let isAllAnswer = true;
          let allItem = this.single.concat(this.checked).concat(this.judge);
          allItem.forEach((item) => {
            if (!item.isAnswer) {
              isAllAnswer = false;
              this.backTop();
            }
          });
          clearTimeout(this.timer);
          if (isAllAnswer) {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          } else {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          }
          // next();
        },
        onCancel() {
          next(false);
        },
      });
    }
  },
  computed: {
    // 倒计时
    endTime() {
      min = parseInt((this.time / 1000 / 60) % 60);
      sec = parseInt((this.time / 1000) % 60);
      min = min > 9 ? min : "0" + min;
      sec = sec > 9 ? sec : "0" + sec;
      return `${
        "0" + parseInt((this.time / 1000 / 60 / 60) % 24)
      }:${min}:${sec}`;
    },
    // 最后试卷得分
    scoreData() {
      let score = 0;
      let itemList = this.single.concat(this.checked).concat(this.judge);
      itemList.forEach((item) => {
        if (item.answer === item.isAnswer) {
          score += item.score;
        }
      });
      return score;
    },
    // 单选总分
    singleTotal() {
      let result = 0;
      this.single.forEach((item) => {
        result += item.score;
      });
      // this.testlist.paperInfo.filter(item=>
      //          item.type==0)

      return result;
    },
    // 多选总分
    checkTotal() {
      let result = 0;
      this.checked.forEach((item) => {
        result += item.score;
      });
      return result;
    },
    // 判断总分
    judgeTotal() {
      let result = 0;
      this.judge.forEach((item) => {
        result += item.score;
      });
      return result;
    },
    // 判断题的序号
    judgeIndex() {
      let index = "";
      if (this.single.length === 0 && this.checked.length === 0) {
        index = "一";
      } else if (this.single.length !== 0 && this.checked.length === 0) {
        index = "二";
      } else if (this.single.length === 0 && this.checked.length !== 0) {
        index = "二";
      } else {
        index = "三";
      }
      return index;
    },
  },
  methods: {
    init() {
      this.getToken(getcourseDetailApi, { courseId: this.testId }, (res) => {
        this.list = res.data;
        this.munelist = res.data.chapters;
      });
      this.getToken(getcatalogApi, { taskId: this.menuId }, (res) => {
        this.info = res.data;
        this.resourceUrl = res.data.resourceUrl;
        this.currentId = this.menuId;
        this.type = res.data.type;
        this.getToken(
          getcatDetail,
          {
            paperId: this.paperId,
            taskId: this.menuId,
            courseId: this.testId,
            type: res.data.type,
            isFinished: res.data.isFinished,
          },
          (res) => {
            if (res.data.userAnswer) {
              this.userAnswer =
                res.data.userAnswer.length == 0 ? null : res.data.userAnswer;
            } else {
              this.time = res.data.examTime * 60 * 1000;
              // this.isChecked=true
            }
            let paperInfo = JSON.parse(
              JSON.parse(
                entry.Decrypt(
                  res.data.theoryQuestion,
                  res.data.key,
                  res.data.iv
                )
              )
            );
            this.testlist = { ...res.data, paperInfo: paperInfo };
            this.single = this.testlist.paperInfo
              .filter((item) => item.type == 0)
              .map((item) => ({ ...item, score: this.testlist.perSingle }));
            this.checked = this.testlist.paperInfo
              .filter((item) => item.type == 1)
              .map((item) => ({ ...item, score: this.testlist.perMulti }));
            this.judge = this.testlist.paperInfo
              .filter((item) => item.type == 2)
              .map((item) => ({ ...item, score: this.testlist.perJudge }));
            if (this.userAnswer) {
              this.checkInit();
              this.isChecked = this.isFinished;
              this.time =
                (this.testlist.examTime - this.testlist.timeUse) * 1000 * 60;
              if (this.isChecked === false) {
                this.countdown();
              }
            } else {
              // this.time = this.testlist.timeUse * 60 * 1000;
              this.countdown();
              this.normalSubmit();
            }
            //解密JSON.parse(JSON.parse(entry.Decrypt...)
            // this.key=entry.Decrypt(res.miyao.key,res.data.key)
            // this.iv=entry.Decrypt(res.miyao.iv,res.data.iv)
            // let paperInfo=res.data.theoryQuestion
          }
        );
      });
    },
    tocourse() {
      this.$router.push({
        path: "/catalogDetail",
        query: {
          id: this.$Base64.encode(this.testId),
          menuId: this.$Base64.encode(this.menuId),
          paperId: this.$Base64.encode(this.paperId),
        },
      });
    },
    goAnchor(selector, offset = -80) {
      // 偏移量
      let top = 0;
      // 获取当前滚动条偏移量
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (typeof selector === "number") {
        top = selector - scrollTop;
      } else {
        // 获取定位元素
        const anchor = document.querySelector(selector) || { offsetTop: 0 };
        top = anchor.offsetTop - scrollTop;
        // 偏移量 = 定位元素的位置 - 当前滚动条的位置
      }
      // 开始滚动， smooth 若为设置则无过渡
      window.scrollBy({ top: top + offset, behavior: "smooth" });
    },
    checkInit() {
      let userAnswer = JSON.parse(this.userAnswer);
      if (this.single.length > 0) {
        this.single.forEach((item) => {
          item.isAnswer = userAnswer.filter(
            (value) => value.id == item.id
          )[0].answer;
        });
      }
      if (this.checked.length > 0) {
        this.checked.forEach((item) => {
          item.isAnswer = userAnswer.filter(
            (value) => value.id == item.id
          )[0].answer;
        });
      }
      if (this.judge.length > 0) {
        this.judge.forEach((item) => {
          item.isAnswer = userAnswer.filter(
            (value) => value.id == item.id
          )[0].answer;
        });
      }
    },
    singleChange(e, item) {
      item.isAnswer = e.target.value;
      this.defaultActiveKey = "1";
      this.normalSubmit();
    },
    checkChange(e, data) {
      this.defaultActiveKey = "2";
      data.isAnswer = e.join("");
      data.isAnswer = data.isAnswer && data.isAnswer.split("").sort().join("");
      this.normalSubmit();
    },
    judgeChange(e, data) {
      this.defaultActiveKey = "3";
      data.isAnswer = e.target.value;
      this.normalSubmit();
    },
    // 监听页面滚动事件
    Scroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.fixed = scrollTop > 246 ? true : false;
    },
    // 回到顶部
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // 交卷
    submitPaper() {
      //交卷改变状态，考试完成
      let single = this.single.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      let checked = this.checked.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      let judge = this.judge.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      //加密Encrypt(JSON.stringify ...)
      this.subinfo.userAnswer = entry.Encrypt(
        JSON.stringify([...single, ...checked, ...judge]),
        "w2SIy2Hx%2i!tTCd-ikwHEv_kQmB58xI",
        "R7#54X&gLB!6Q&s="
      );
      this.subinfo.timeUse =
        (this.testlist.examTime * 60 * 1000 - this.time) / 1000 / 60;
      this.subinfo.paperId = this.paperId;
      this.subinfo.type = this.type;
      this.getToken(
        getcommitPaperApi,
        {
          ...this.subinfo,
          startTime: formatDate("yyyy-MM-dd hh:mm:ss", new Date()),
        },
        (res) => {
          if (res.code == 200) {
            this.getToken(
              getupdateStatusApi,
              {
                taskId: this.subinfo.taskId,
                courseId: this.subinfo.courseId,
                status: 1,
              },
              () => {
                this.$store.commit("getIds", {
                  chapterId: this.chapterId,
                  taskId: this.subinfo.taskId,
                });
              }
            );
          }
        }
      );
      let isAllAnswer = true;
      let allItem = this.single.concat(this.checked).concat(this.judge);
      allItem.forEach((item) => {
        if (!item.isAnswer) {
          isAllAnswer = false;
          this.backTop();
        }
      });
      if (isAllAnswer) {
        this.$confirm({
          title: "你确认要交卷吗？",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          },
        });
      } else {
        this.$confirm({
          title: "题目还未答完，确认交卷吗?",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          },
          onCancel() {},
        });
      }
    },
    // 刷新页面
    onceTest() {
      this.$router.go(0);
      this.isChecked = false;
      // this.testInit()
    },
    // 定时提交
    normalSubmit() {
      let single = this.single.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      let checked = this.checked.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      let judge = this.judge.map((item) => ({
        id: item.id,
        answer: item.isAnswer && item.isAnswer,
      }));
      this.subinfo.userAnswer = entry.Encrypt(
        JSON.stringify([...single, ...checked, ...judge]),
        "w2SIy2Hx%2i!tTCd-ikwHEv_kQmB58xI",
        "R7#54X&gLB!6Q&s="
      );
      this.subinfo.timeUse =
        (this.testlist.examTime * 60 * 1000 - this.time) / 1000 / 60;
      this.subinfo.paperId = this.paperId;
      this.subinfo.type = this.type;
      this.getToken(
        getscheduledAnswerApi,
        {
          ...this.subinfo,
          startTime: formatDate("yyyy-MM-dd hh:mm:ss", new Date()),
        },
        () => {}
      );
      this.during_time = 0;
    },
    countdown() {
      this.timer = setTimeout(() => {
        this.during_time++;
        if (this.during_time >= 5) {
          this.normalSubmit();
        }

        if (this.time <= 0) {
          let single = this.single.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          let checked = this.checked.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          let judge = this.judge.map((item) => ({
            id: item.id,
            answer: item.isAnswer && item.isAnswer,
          }));
          //加密Encrypt(JSON.stringify ...)
          this.subinfo.userAnswer = entry.Encrypt(
            JSON.stringify([...single, ...checked, ...judge]),
            "w2SIy2Hx%2i!tTCd-ikwHEv_kQmB58xI",
            "R7#54X&gLB!6Q&s="
          );
          this.subinfo.timeUse =
            (this.testlist.examTime * 60 * 1000 - this.time) / 1000 / 60;
          this.subinfo.paperId = this.paperId;
          this.subinfo.type = this.type;
          this.getToken(
            getcommitPaperApi,
            {
              ...this.subinfo,
              startTime: formatDate("yyyy-MM-dd hh:mm:ss", new Date()),
            },
            () => {
              this.getToken(
                getupdateStatusApi,
                {
                  taskId: this.subinfo.taskId,
                  courseId: this.subinfo.courseId,
                  status: 1,
                },
                () => {
                  this.$store.commit("getIds", {
                    chapterId: this.chapterId,
                    taskId: this.subinfo.taskId,
                  });
                }
              );
            }
          );
          let isAllAnswer = true;
          let allItem = this.single.concat(this.checked).concat(this.judge);
          allItem.forEach((item) => {
            if (!item.isAnswer) {
              isAllAnswer = false;
              this.backTop();
            }
          });
          clearTimeout(this.time);
          if (isAllAnswer) {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          } else {
            this.isChecked = true;
            clearTimeout(this.timer);
            this.backTop();
          }
        } else {
          this.time -= 1000;
          this.countdown();
          // console.log(123);
        }
      }, 1000);
    },
  },
  destroyed() {
    window.onbeforeunload = null;
    window.clearTimeout(this.timer);
  },
};
</script>

<style lang="stylus" scoped>
.theoryexam .ant-menu-sub.ant-menu-inline {
  background: #eee;
}

.theoryexam .ant-menu-inline .ant-menu-submenu-title {
  margin-bottom: 0px;
}

.theoryexam .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #4483fa;
  color: #fff;
  margin: 0px;
}

.theoryexam .ant-menu-inline .ant-menu-item::after {
  border-right: 0px;
}

.theoryexam .ant-menu-sub.ant-menu-inline > .ant-menu-item, .theoryexam .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 45px;
  line-height: 45px;
  list-style-position: inside;
  list-style-type: disc;
  margin: 0px;
  padding-left: 25px !important;
}

.theoryexam .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  background: #fff;
  padding-left: 16px !important;
}

.theoryexam .ant-menu-inline .ant-menu-submenu-title {
  margin-top: 0;
}

.theoryexam .ant-menu-inline .ant-menu-submenu {
  padding-bottom: 16px;
  background: #eee;
  margin-bottom: 0;
}

.theoryexam .Right .title[data-v-175b7694] {
  height: 65px;
  border-bottom: 1px solid #eee;
  margin-left: 0px;
  margin-right: 0px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}
</style>
<style>
.left .answer .ant-checkbox-wrapper + span,
.ant-checkbox + span {
  padding-left: 16px;
  font-size: 16px;
  line-height: 1.8;
  font-size: 16px;
}
.is_checked .ant-radio-checked:before {
  width: 20px;
  height: 20px;
  background: url("../assets/course/radio_active.png") no-repeat;
  background-size: 85%;
  content: "";
  display: block;
  position: absolute;

  z-index: 2;
}
.is_checked .ant-checkbox-checked:before {
  width: 20px;
  height: 20px;
  background: url("../assets/course/checkbox_active.png") no-repeat;
  background-size: 85%;
  content: "";
  display: block;
  position: absolute;
  z-index: 2;
}
.ant-back-top {
  position: fixed;
  right: 75px;
  bottom: 50px;
}
</style>
<style lang="stylus" scoped>
.theoryexam {
  border-top: 1px solid #ccc;

  .exampaper {
    margin: 0 auto;
    // margin-top: 24px;
    // margin-left: 33px;
    // margin-bottom: 50px;
    overflow: hidden;
    min-height: 700px;
    background: #E8E8E8;

    .paper {
      background: #E8E8E8;
      padding-top: 30px;
      color: #333;
      font-size: 16px;
      padding-bottom: 80px;
      min-width: 1200px;

      .content {
        width: 1200px;
        margin: 0 auto;

        .header {
          background: #fff;
          text-align: center;
          position: relative;

          &:before {
            content: '';
            display: table;
          }

          p {
            margin-top: 30px;
          }

          h2 {
            font-size: 24px;
            min-heigth: 100px;
            line-height: 100px;
          }

          .back {
            border: 0;
            outline: none;
            width: 99px;
            height: 30px;
            background-color: #ffffff;
            border: solid 1px #cecece;
            color: #f0cd48;
            font-size: 12px;
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translateY(-50%);
          }

          span {
            color: #999;
            font-size: 14px;
          }

          .score {
            font: 50px '微软雅黑';
            color: #dd0000;
            position: absolute;
            left: 80px;
            top: 35px;
            width: 100px;
            height: 80px;
            background: url('../assets/course/score.png') 50% 100% no-repeat;
          }

          .paperTotal {
            margin: 5px 30px 0;
            border-top: 1px dashed #e5e5e5;
            text-align: left;
            line-height: 67px;

            b {
              font-weight: normal;
              font-size: 14px;
            }
          }

          .normal_exam_info {
            span {
              margin-left: 20px;
            }
          }
        }

        .body {
          display: flex;
          justify-content: space-between;

          .left {
            width: 920px;

            .title {
              background: #FFF9E9;
              border: 1px solid #ffeec4;
              font-size: 14px;
              padding: 20px 30px;
              margin-top: 15px;
            }

            .item {
              background: #fff;
              margin-top: 15px;
              display: block;
              color: #333;
              position: relative;
              padding-bottom: 3px;

              img {
                position: absolute;
                top: 0;
                right: 0;
              }

              .stem {
                padding: 7px 30px;
                background: #F9F9FA;
              }

              .answer {
                padding: 15px 30px;
              }

              .question_analysis {
                width: 95%;
                margin: 0 auto;
                padding: 30px;
                background: #F9F9FA;
                margin-bottom: 20px;
                border: 1px solid #e8e8e8;
                position: relative;
                margin-top: 10px;

                &:after {
                  display: block;
                  content: '';
                  width: 33px;
                  height: 17px;
                  position: absolute;
                  left: 50px;
                  top: -12px;
                  background: url('../assets/course/triangle.png');
                }

                p {
                  color: #a0a0a0;

                  .right_answer {
                    color: #36c075;
                  }

                  .my_answer {
                    color: #e45c40;
                  }

                  i {
                    display: inline-block;
                    width: 30px;
                  }
                }
              }
            }
          }

          .right {
            float: right;
            width: 265px;
            margin-top: 15px;
            height: fit-content;

            .header {
              padding: 19px;
              border: 1px solid #ddd;
              border-bottom: 0;
              color: #e45c40;

              span {
                margin: 0 10px;
                font-size: 16px;
                color: #333;
              }
            }

            .right_content {
              .index {
                display: inline-block;
                text-align: center;
                border: 1px solid #b1b6bf;
                width: 28px;
                line-height: 26px;
                margin-right: 5px;
                margin-bottom: 5px;
                color: #333;
              }

              .isAnswer {
                background: #B1B6BF;
                color: #fff;
                border-color: #B1B6BF;
              }

              .right_item {
                background: #36C176;
                color: #fff;
                border-color: #36C176;
              }

              .wrong_item {
                background: #E45C40;
                color: #fff;
                border-color: #E45C40;
              }
            }

            .footer {
              background: #fff;
              border: 1px solid #ddd;
              border-top: 0;
              text-align: center;
              padding-top: 5px;

              button {
                width: 85%;
                margin: 0 auto;
                color: #fff;
                background: #e45c40;
                border: none;
                border-radius: 0;
                line-height: 40px;
                margin: 20px 0;
                font-size: 14px;
                outline: none;
              }

              cite {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: #B1B6BF;
                margin-left: 5px;
              }

              .had {
                margin-right: 10px;
              }

              .not_had {
                background: #fff;
                border: 1px solid #ddd;
              }

              .return {
                background: #fff;
                border: 1px solid #e45c40;
                color: #e45c40;
                margin-top: 0;
              }

              .right_target {
                background: #36C176;
                border: 1px solid #36C176;
              }

              .wrong_target {
                background: #E45C40;
                border: 1px solid #E45C40;
              }
            }
          }

          .fixed {
            position: fixed;
            top: 100px;
            right: calc(((100% - 1220px) / 2));
          }
        }
      }

      .back_top {
        width: 45px;
        height: 45px;
        background: #c3c3c3;
        text-decoration: none;
        position: fixed;
        right: 75px;
        top: calc(100% - 150px);
        box-shadow: 0 0 5px #aaa;
        cursor: pointer;
        text-align: center;
        line-height: 45px;
        color: #fff;
      }
    }
  }
}
</style>
